export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Delete-Gray-aff2cd9ae0b8e6cb95568f202992d85c.svg";